import { defineComponent as o } from "vue";
import { trackLink as m, TrackingType as u, createTealiumTracking as f } from "@sunrise/tracking";
import { getBaseTracking as l } from "./index570.js";
import s from "./index40.js";
import y from "./index194.js";
const C = o({
  name: "MsHeaderLinks",
  components: {
    MsTextLink: y,
    CsSecondaryButton: s
  },
  props: {
    primaryAction: Object,
    secondaryAction: Object,
    channelName: {
      type: String,
      required: !0
    }
  },
  setup(n) {
    function t(e) {
      n.primaryAction && a(e, n.primaryAction, n.channelName, "cta_primary");
    }
    function r(e) {
      n.secondaryAction && a(e, n.secondaryAction, n.channelName, "cta_secondary");
    }
    return {
      onPrimaryClick: t,
      onSecondaryClick: r
    };
  }
});
function a(n, t, r, e) {
  const i = n.currentTarget, c = k(t, r, e);
  m(n, i, [c]);
}
function k(n, t, r) {
  const e = {
    ...l(),
    mslayer_element_position: r,
    mslayer_element_text: d(n, t)
  };
  return {
    ...f(e),
    when: u.CLICK
  };
}
function d(n, t) {
  return `navi_cta_${t}_${_(n.text)}`;
}
function _(n) {
  return n.replace(/ /g, "_");
}
export {
  C as default
};
